export const Collections = {
    projects: 'project',
    featureFlags: 'feature_flag',
    roles: 'role',
    projectRoleUser: 'project_role_user',
    environment: 'environment',
    users: 'user'
};
